import { BasePanelController } from '../../../../../BaseUI/BasePanelController';
import { ReserveDetailPanelComponent } from './ReserveDetailPanelComponent';
import {ReserveService} from '../../../../../../Service/ReserveService';
import {ReservationDTOInterface} from '../../../../../../DTO/ReservationDTOInterface';
import {ReservationDetailDTOInterface} from '../../../../../../DTO/ReservationDetailDTOInterface';

export class ReserveDetailPanelController extends BasePanelController {

	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのViewと紐づくか明示する為。
	public combineView: ReserveDetailPanelComponent;


	public async cancelReservation(param: {view: any; data: ReservationDTOInterface}): Promise<any> {

		const srv = new ReserveService(param.view);
		const res = srv.cancelReservation({
			data: param.data
		});

		return res;
	}


	/**
	 * 予約詳細画面のデータ取得
	 * @param param
	 */
	public async getReserveDetailViewData(param: {view: any; reserveId: number}): Promise<{
		reservation: ReservationDetailDTOInterface;
		updateDeadline: string;
		cancelDeadline: string;
	}> {

		const reserveService = new ReserveService(param.view);
		const res = await reserveService.getReserveDetailViewData(param.reserveId);

		return res;

	}

	/**
	 * 予約キャンセルメッセージの送信
	 * @param param
	 */
	public async sendReserveCancelMessage(param: {view: any; reserveId: number}): Promise<any> {
		const svc = new ReserveService(param.view);
		const ret = await svc.sendReserveCancelMessage(param.reserveId);

		return ret;
	}
}
